export default {
  blue: {
    primaryColor: '#2973F9',
    redColor: '#E4463B',
    orangeColor: '#FD613F',
    greenColor: '0084FF',
    balckColor: '#3D3D3D',
    bgColor: '#535C61',
    grayColor: '#999999',
  },
  green: {
    primaryColor: '#01CCB8',
    redColor: '#E4463B',
    orangeColor: '#FD613F',
    greenColor: '0084FF',
    balckColor: '#3D3D3D',
    bgColor: '#535C61',
    grayColor: '#999999',
  },
}
